<div class="content-block">
  <h2 class="content-block_header h3-header">{{ pageTitle }}</h2>

  <form [formGroup]="form" novalidate>
    <div class="fields__block">
      <label i18n class="field__label">What is the origin of your assets?</label>
      <div formArrayName="originOfAssets" class="field__item" novalidate>

        <div class="checkbox__field" *ngFor="let origin of form.get('originOfAssets')['controls']; let i=index">
          <div [formGroupName]="i">
            <input class="checkbox__field" type="checkbox" formControlName="value" [id]="origin.value.id">
            <label class="checkbox__label" [attr.data-tests-id]="'origin-of-assets-' + i" [for]="origin.value.id">{{ origin.value.name }}</label>
            <span class="checkbox__check"></span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="row buttons_row">
  <div class="col-xs-6">
    <a i18n="@@back" class="btn bc-btn bc-btn_block bc-btn_default" [routerLink]="['../additional']">Back</a>
  </div>
  <div class="col-xs-6">
    <button type="button" data-tests-id="origin-of-assets-next" class="btn bc-btn bc-btn_block bc-btn_custom" [disabled]="form.invalid" (click)="proceed()"
      [disabled]="form.invalid">
      <ng-container i18n="@@submitDetails">Submit</ng-container>
    </button>
  </div>
</div>
